// import React, { useState, useEffect, useCallback } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { useCart } from "../context/CartContext";
// import {
//   createRazorpayOrder,
//   verifyRazorpayPayment,
//   placeOrderAPI,
// } from "../services/orderService";
// import {
//   applyReferralCodeAPI,
//   applyLoyaltyDiscountAPI,
//   removeLoyaltyDiscountAPI,
//   getMyReferralInfoAPI,
// } from "../services/referralService";

// const STORAGE_KEY = "sanjivani_checkout_info";
// const fmt = (n) => "₹" + Number(n).toLocaleString("en-IN");

// const INDIAN_STATES = [
//   "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
//   "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
//   "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
//   "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
//   "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
//   "Andaman and Nicobar Islands", "Chandigarh", "Delhi", "Jammu and Kashmir",
//   "Ladakh", "Lakshadweep", "Puducherry",
// ];

// const loadRazorpayScript = () =>
//   new Promise((resolve) => {
//     if (document.getElementById("razorpay-sdk")) { resolve(true); return; }
//     const script = document.createElement("script");
//     script.id = "razorpay-sdk";
//     script.src = "https://checkout.razorpay.com/v1/checkout.js";
//     script.onload = () => resolve(true);
//     script.onerror = () => resolve(false);
//     document.body.appendChild(script);
//   });

// function validate(fields) {
//   const errors = {};
//   if (!fields.name.trim()) errors.name = "Full name is required.";
//   else if (fields.name.trim().length < 3) errors.name = "Name must be at least 3 characters.";
//   if (!fields.phone.trim()) errors.phone = "Phone number is required.";
//   else if (!/^[6-9]\d{9}$/.test(fields.phone.trim())) errors.phone = "Enter a valid 10-digit Indian mobile number.";
//   if (!fields.email.trim()) errors.email = "Email address is required.";
//   else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email.trim())) errors.email = "Enter a valid email address.";
//   if (!fields.address.trim()) errors.address = "Street address is required.";
//   else if (fields.address.trim().length < 10) errors.address = "Please enter a complete address.";
//   if (!fields.city.trim()) errors.city = "City is required.";
//   if (!fields.state) errors.state = "Please select your state.";
//   if (!fields.pincode.trim()) errors.pincode = "Pincode is required.";
//   else if (!/^\d{6}$/.test(fields.pincode.trim())) errors.pincode = "Enter a valid 6-digit pincode.";
//   return errors;
// }

// const STEPS = ["Cart", "Delivery", "Payment"];

// function StepBar({ current }) {
//   return (
//     <div className="stepbar">
//       {STEPS.map((s, i) => (
//         <React.Fragment key={s}>
//           <div className={`step ${i < current ? "step--done" : i === current ? "step--active" : ""}`}>
//             <div className="step__circle">{i < current ? <span>✓</span> : <span>{i + 1}</span>}</div>
//             <span className="step__label">{s}</span>
//           </div>
//           {i < STEPS.length - 1 && <div className={`step__line ${i < current ? "step__line--done" : ""}`} />}
//         </React.Fragment>
//       ))}
//     </div>
//   );
// }

// function Field({ label, id, error, required, children, hint }) {
//   return (
//     <div className={`field ${error ? "field--error" : ""}`}>
//       <label className="field__label" htmlFor={id}>
//         {label}{required && <span className="field__req">*</span>}
//       </label>
//       {children}
//       {hint && !error && <p className="field__hint">{hint}</p>}
//       {error && <p className="field__error">{error}</p>}
//     </div>
//   );
// }

// function OrderSummary({ items, subtotal, referralDiscount, loyaltyDiscount, shipping, total, coupon }) {
//   const [open, setOpen] = useState(true);

//   return (
//     <aside className="order-summary">
//       <button className="os-toggle" onClick={() => setOpen(o => !o)}>
//         <span className="os-toggle__label">
//           🛒 Order Summary
//           <span className="os-toggle__count">{items.length} item{items.length !== 1 ? "s" : ""}</span>
//         </span>
//         <span className="os-toggle__total">{fmt(total)}</span>
//         <span className="os-toggle__arrow">{open ? "▲" : "▼"}</span>
//       </button>

//       {open && (
//         <div className="os-body">
//           <div className="os-items">
//             {items.map(item => (
//               <div className="os-item" key={item.id}>
//                 <div className="os-item__img">
//                   {(() => {
//                     const src = Array.isArray(item.emoji) ? item.emoji[0] : item.emoji;
//                     const str = typeof src === "string" ? src : "";
//                     return str.startsWith("http")
//                       ? <img src={str} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }} />
//                       : <span>{str || "🌿"}</span>;
//                   })()}
//                   <span className="os-item__qty">{item.quantity}</span>
//                 </div>
//                 <div className="os-item__info">
//                   <span className="os-item__name">{item.name}</span>
//                   {item.category && <span className="os-item__cat">{item.category}</span>}
//                 </div>
//                 <span className="os-item__price">{fmt(item.price * item.quantity)}</span>
//               </div>
//             ))}
//           </div>

//           <div className="os-divider" />

//           <div className="os-rows">
//             <div className="os-row"><span>Subtotal</span><span>{fmt(subtotal)}</span></div>
//             {coupon?.discountAmount > 0 && (
//               <div className="os-row os-row--green">
//                 <span>Coupon ({coupon.code})</span>
//                 <span>−{fmt(coupon.discountAmount)}</span>
//               </div>
//             )}
//             {referralDiscount > 0 && (
//               <div className="os-row os-row--green">
//                 <span>Referral Discount (10%)</span>
//                 <span>−{fmt(referralDiscount)}</span>
//               </div>
//             )}
//             {loyaltyDiscount > 0 && (
//               <div className="os-row os-row--green">
//                 <span>Loyalty Offer (50% off)</span>
//                 <span>−{fmt(loyaltyDiscount)}</span>
//               </div>
//             )}
//             <div className="os-row">
//               <span>Shipping</span>
//               <span>{shipping === 0 ? <span className="free-tag">FREE</span> : fmt(shipping)}</span>
//             </div>
//           </div>

//           <div className="os-divider" />

//           <div className="os-total">
//             <span>Total</span>
//             <span className="os-total__val">{fmt(total)}</span>
//           </div>
//           <p className="os-note">🔒 All transactions are secured & encrypted</p>
//         </div>
//       )}
//     </aside>
//   );
// }

// const EMPTY_FORM = {
//   name: "", phone: "", email: "",
//   address: "", city: "", state: "", pincode: "",
//   saveInfo: true,
// };

// export default function Checkout() {
//   const navigate = useNavigate();
//   const { items, subtotal, shipping, coupon, itemCount, clearCart } = useCart();

//   const [fields, setFields] = useState(EMPTY_FORM);
//   const [errors, setErrors] = useState({});
//   const [touched, setTouched] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [payStep, setPayStep] = useState("");
//   const [orderCompleted, setOrderCompleted] = useState(false);

//   // Referral
//   const [referralCode, setReferralCode] = useState("");
//   const [referralApplied, setReferralApplied] = useState(false);
//   const [referralDiscount, setReferralDiscount] = useState(0);
//   const [referralMsg, setReferralMsg] = useState({ text: "", type: "" });
//   const [referralLoading, setReferralLoading] = useState(false);

//   // Loyalty
//   const [loyaltyInfo, setLoyaltyInfo] = useState(null);
//   const [loyaltyApplied, setLoyaltyApplied] = useState(false);
//   const [loyaltyDiscount, setLoyaltyDiscount] = useState(0);
//   const [loyaltyLoading, setLoyaltyLoading] = useState(false);

//   const couponDiscount = coupon?.discountAmount || 0;
//   const total = Math.max(0, subtotal - couponDiscount - referralDiscount - loyaltyDiscount + shipping);

//   // Load loyalty info
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) return;
//     getMyReferralInfoAPI().then(result => {
//       if (result?.success) setLoyaltyInfo(result.data);
//     });
//   }, []);

//   // Restore saved info
//   useEffect(() => {
//     try {
//       const saved = localStorage.getItem(STORAGE_KEY);
//       if (saved) setFields(prev => ({ ...prev, ...JSON.parse(saved), saveInfo: true }));
//     } catch { }
//   }, []);

//   // Redirect if cart empty
//   useEffect(() => {
//     if (itemCount === 0 && !orderCompleted) navigate("/products");
//   }, [itemCount, orderCompleted, navigate]);

//   // Validate on touch
//   useEffect(() => {
//     if (Object.keys(touched).length > 0) setErrors(validate(fields));
//   }, [fields, touched]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFields(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
//   };
//   const handleBlur = (e) => setTouched(prev => ({ ...prev, [e.target.name]: true }));

//   // Apply referral code
//   const handleApplyReferral = async () => {
//     if (!referralCode.trim()) return;
//     setReferralLoading(true);
//     setReferralMsg({ text: "", type: "" });
//     const result = await applyReferralCodeAPI(referralCode.trim());
//     setReferralLoading(false);
//     if (result?.success) {
//       const disc = Math.round(subtotal * 0.10);
//       setReferralDiscount(disc);
//       setReferralApplied(true);
//       setReferralMsg({ text: `✓ Referral applied! You save ${fmt(disc)}`, type: "success" });
//     } else {
//       setReferralMsg({ text: result?.message || "Invalid referral code.", type: "error" });
//     }
//   };

//   const handleRemoveReferral = () => {
//     setReferralApplied(false);
//     setReferralDiscount(0);
//     setReferralCode("");
//     setReferralMsg({ text: "", type: "" });
//   };

//   // Apply loyalty discount
//   const handleApplyLoyalty = async () => {
//     setLoyaltyLoading(true);
//     const result = await applyLoyaltyDiscountAPI();
//     setLoyaltyLoading(false);
//     if (result?.success) {
//       const paidItems = items.filter(i => !i.isFree);
//       const cheapest = [...paidItems].sort((a, b) => a.price - b.price)[0];
//       const disc = cheapest ? Math.round(cheapest.price * cheapest.quantity * 0.50) : 0;
//       setLoyaltyDiscount(disc);
//       setLoyaltyApplied(true);
//     }
//   };

//   const handleRemoveLoyalty = async () => {
//     await removeLoyaltyDiscountAPI();
//     setLoyaltyApplied(false);
//     setLoyaltyDiscount(0);
//   };

//   // Payment flow
//   const handleSubmit = useCallback(async (e) => {
//     e.preventDefault();
//     const allTouched = Object.fromEntries(Object.keys(fields).map(k => [k, true]));
//     setTouched(allTouched);
//     const errs = validate(fields);
//     setErrors(errs);
//     if (Object.keys(errs).length > 0) {
//       document.querySelector(".field--error")?.scrollIntoView({ behavior: "smooth", block: "center" });
//       return;
//     }

//     if (fields.saveInfo) {
//       try { const { saveInfo, ...toSave } = fields; localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave)); } catch { }
//     } else {
//       localStorage.removeItem(STORAGE_KEY);
//     }

//     setSubmitting(true);
//     setPayStep("creating");

//     try {
//       const sdkLoaded = await loadRazorpayScript();
//       if (!sdkLoaded) {
//         alert("Failed to load Razorpay. Please try again.");
//         setSubmitting(false); setPayStep(""); return;
//       }

//       const orderResult = await createRazorpayOrder(total);
//       if (!orderResult?.success) {
//         alert(orderResult?.message || "Failed to initiate payment.");
//         setSubmitting(false); setPayStep(""); return;
//       }

//       const { orderId: razorpayOrderId, amount, keyId } = orderResult.data;
//       setPayStep("redirecting");

//       await new Promise((resolve, reject) => {
//         const options = {
//           key: keyId, amount, currency: "INR",
//           name: "Sanjivani Ayurveda",
//           description: `Order of ${itemCount} item${itemCount !== 1 ? "s" : ""}`,
//           order_id: razorpayOrderId,
//           prefill: {
//             name: fields.name.trim(),
//             email: fields.email.trim(),
//             contact: `+91${fields.phone.trim()}`,
//           },
//           theme: { color: "#2d6a4f" },
//           modal: { ondismiss: () => reject(new Error("PAYMENT_CANCELLED")) },
//           handler: async (response) => {
//             try {
//               setPayStep("placing");
//               const verifyResult = await verifyRazorpayPayment({
//                 razorpay_order_id: response.razorpay_order_id,
//                 razorpay_payment_id: response.razorpay_payment_id,
//                 razorpay_signature: response.razorpay_signature,
//               });
//               if (!verifyResult?.success) {
//                 alert("Payment verification failed. Contact support: " + response.razorpay_payment_id);
//                 reject(new Error("VERIFICATION_FAILED")); return;
//               }

//               const placeResult = await placeOrderAPI({
//                 shippingAddress: {
//                   fullName: fields.name.trim(),
//                   phone: fields.phone.trim(),
//                   addressLine1: fields.address.trim(),
//                   city: fields.city.trim(),
//                   state: fields.state,
//                   pincode: fields.pincode.trim(),
//                 },
//                 paymentMethod: "razorpay",
//                 razorpayOrderId: response.razorpay_order_id,
//                 razorpayPaymentId: response.razorpay_payment_id,
//                 useReferralDiscount: referralApplied,
//                 useLoyaltyDiscount: loyaltyApplied,
//               });

//               if (!placeResult?.success) {
//                 alert(placeResult?.message || "Order placement failed. Contact support.");
//                 reject(new Error("ORDER_PLACEMENT_FAILED")); return;
//               }

//               await clearCart();
//               const orderId = placeResult.data?.order?.id || placeResult.data?.order?._id;
//               setOrderCompleted(true);
//               resolve(orderId);
//             } catch (err) { reject(err); }
//           },
//         };

//         const rzp = new window.Razorpay(options);
//         rzp.on("payment.failed", (r) => reject(new Error(`PAYMENT_FAILED: ${r.error?.description || "Unknown"}`)));
//         rzp.open();
//       })
//         .then((orderId) => navigate(`/order-confirmation/${orderId}`))
//         .catch((err) => {
//           if (err.message !== "PAYMENT_CANCELLED" && err.message?.startsWith("PAYMENT_FAILED")) {
//             alert("Payment failed: " + err.message.replace("PAYMENT_FAILED: ", ""));
//           }
//           setSubmitting(false); setPayStep("");
//         });

//     } catch (err) {
//       console.error("Checkout error:", err);
//       alert("Something went wrong. Please try again.");
//       setSubmitting(false); setPayStep("");
//     }
//   }, [fields, total, itemCount, clearCart, navigate, referralApplied, loyaltyApplied]);

//   const inputClass = (name) => `input ${errors[name] && touched[name] ? "input--error" : ""}`;
//   const payBtnLabel = () => {
//     if (!submitting) return `🔒 Pay ${fmt(total)} Now`;
//     if (payStep === "creating") return "Creating order…";
//     if (payStep === "redirecting") return "Opening Razorpay…";
//     if (payStep === "placing") return "Placing your order…";
//     return "Processing…";
//   };

//   return (
//     <>
//       <style>{css}</style>
//       <div className="co-page">

//         <div className="co-bc">
//           <div className="co-container">
//             <Link to="/">Home</Link><span>›</span>
//             <Link to="/cart">Cart</Link><span>›</span>
//             <span className="co-bc__cur">Checkout</span>
//           </div>
//         </div>

//         <div className="co-header">
//           <div className="co-container">
//             <h1 className="co-header__title">Checkout</h1>
//             <p className="co-header__sub">Almost there — complete your order below</p>
//           </div>
//         </div>

//         <div className="co-container co-body">
//           <StepBar current={1} />

//           <div className="co-layout">
//             <OrderSummary
//               items={items} subtotal={subtotal}
//               referralDiscount={referralDiscount} loyaltyDiscount={loyaltyDiscount}
//               shipping={shipping} total={total} coupon={coupon}
//             />

//             <form className="co-form" onSubmit={handleSubmit} noValidate>

//               {/* Personal Info */}
//               <section className="form-section">
//                 <div className="form-section__header">
//                   <span className="form-section__num">1</span>
//                   <h2 className="form-section__title">Personal Information</h2>
//                 </div>
//                 <div className="form-grid">
//                   <Field label="Full Name" id="name" error={touched.name && errors.name} required>
//                     <input className={inputClass("name")} id="name" name="name" type="text"
//                       placeholder="Priya Sharma" value={fields.name}
//                       onChange={handleChange} onBlur={handleBlur} autoComplete="name" />
//                   </Field>
//                   <Field label="Mobile Number" id="phone" error={touched.phone && errors.phone} required hint="10-digit Indian mobile number">
//                     <div className="input-prefix-wrap">
//                       <span className="input-prefix">+91</span>
//                       <input className={inputClass("phone") + " input--prefix"} id="phone" name="phone"
//                         type="tel" placeholder="98765 43210" value={fields.phone}
//                         onChange={handleChange} onBlur={handleBlur} maxLength={10} autoComplete="tel" />
//                     </div>
//                   </Field>
//                   <Field label="Email Address" id="email" error={touched.email && errors.email} required hint="Order confirmation will be sent here">
//                     <input className={inputClass("email") + " field--full"} id="email" name="email"
//                       type="email" placeholder="priya@example.com" value={fields.email}
//                       onChange={handleChange} onBlur={handleBlur} autoComplete="email" />
//                   </Field>
//                 </div>
//               </section>

//               {/* Delivery Address */}
//               <section className="form-section">
//                 <div className="form-section__header">
//                   <span className="form-section__num">2</span>
//                   <h2 className="form-section__title">Delivery Address</h2>
//                 </div>
//                 <div className="form-grid">
//                   <Field label="Street Address" id="address" error={touched.address && errors.address} required>
//                     <textarea className={inputClass("address") + " textarea field--full"} id="address" name="address"
//                       placeholder="House no., Street name, Landmark…" value={fields.address}
//                       onChange={handleChange} onBlur={handleBlur} rows={3} autoComplete="street-address" />
//                   </Field>
//                   <Field label="City / District" id="city" error={touched.city && errors.city} required>
//                     <input className={inputClass("city")} id="city" name="city" type="text"
//                       placeholder="Ahmedabad" value={fields.city}
//                       onChange={handleChange} onBlur={handleBlur} autoComplete="address-level2" />
//                   </Field>
//                   <Field label="State" id="state" error={touched.state && errors.state} required>
//                     <select className={inputClass("state") + " select"} id="state" name="state"
//                       value={fields.state} onChange={handleChange} onBlur={handleBlur}>
//                       <option value="">Select state…</option>
//                       {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
//                     </select>
//                   </Field>
//                   <Field label="PIN Code" id="pincode" error={touched.pincode && errors.pincode} required>
//                     <input className={inputClass("pincode")} id="pincode" name="pincode" type="text"
//                       placeholder="380001" value={fields.pincode}
//                       onChange={handleChange} onBlur={handleBlur} maxLength={6} autoComplete="postal-code" />
//                   </Field>
//                 </div>
//               </section>

//               {/* Save info */}
//               <div className="save-row">
//                 <label className="checkbox-label">
//                   <input type="checkbox" name="saveInfo" checked={fields.saveInfo} onChange={handleChange} className="checkbox" />
//                   <span className="checkbox__box" />
//                   <span className="checkbox__text">Save my details for faster checkout next time</span>
//                 </label>
//               </div>

//               {/* Offers */}
//               <section className="form-section form-section--offers">
//                 <div className="form-section__header">
//                   <span className="form-section__num">3</span>
//                   <h2 className="form-section__title">Offers & Discounts</h2>
//                 </div>

//                 {/* Loyalty unlocked banner */}
//                 {loyaltyInfo?.loyaltyDiscountUnlocked && !loyaltyApplied && (
//                   <div className="offer-banner offer-banner--loyalty">
//                     <div className="offer-banner__left">
//                       <span className="offer-banner__icon">🎁</span>
//                       <div>
//                         <p className="offer-banner__title">Loyalty Offer Unlocked!</p>
//                         <p className="offer-banner__sub">You've bought 4 items — get 50% off your cheapest item now</p>
//                       </div>
//                     </div>
//                     <button type="button" className="offer-banner__btn" onClick={handleApplyLoyalty} disabled={loyaltyLoading}>
//                       {loyaltyLoading ? "Applying…" : "Apply"}
//                     </button>
//                   </div>
//                 )}

//                 {loyaltyApplied && (
//                   <div className="offer-applied offer-applied--loyalty">
//                     <span>🎁 Loyalty offer applied — {fmt(loyaltyDiscount)} saved!</span>
//                     <button type="button" className="offer-remove" onClick={handleRemoveLoyalty}>✕ Remove</button>
//                   </div>
//                 )}

//                 {/* Purchase counter progress */}
//                 {loyaltyInfo && !loyaltyInfo.loyaltyDiscountUnlocked && (
//                   <div className="purchase-progress">
//                     <div className="pp-header">
//                       <span className="pp-title">🌿 Loyalty Progress</span>
//                       <span className="pp-count">{loyaltyInfo.purchaseCounter}/4 items</span>
//                     </div>
//                     <div className="pp-bar">
//                       <div className="pp-bar__fill" style={{ width: `${Math.min((loyaltyInfo.purchaseCounter / 4) * 100, 100)}%` }} />
//                     </div>
//                     <p className="pp-hint">
//                       Buy {4 - loyaltyInfo.purchaseCounter} more item{4 - loyaltyInfo.purchaseCounter !== 1 ? "s" : ""} to unlock 50% off your next purchase!
//                     </p>
//                   </div>
//                 )}

//                 {/* Referral code */}
//                 {!referralApplied ? (
//                   <div className="referral-input-wrap">
//                     <p className="referral-label">Have a referral code? Get 10% off</p>
//                     <div className="referral-row">
//                       <input
//                         className="input referral-input"
//                         type="text"
//                         placeholder="Enter referral code (e.g. SAYPRIY3A)"
//                         value={referralCode}
//                         onChange={e => { setReferralCode(e.target.value.toUpperCase()); setReferralMsg({ text: "", type: "" }); }}
//                         maxLength={12}
//                       />
//                       <button type="button" className="referral-apply-btn"
//                         onClick={handleApplyReferral}
//                         disabled={referralLoading || !referralCode.trim()}>
//                         {referralLoading ? "…" : "Apply"}
//                       </button>
//                     </div>
//                     {referralMsg.text && (
//                       <p className={`referral-msg referral-msg--${referralMsg.type}`}>{referralMsg.text}</p>
//                     )}
//                   </div>
//                 ) : (
//                   <div className="offer-applied offer-applied--referral">
//                     <span>🎉 Referral applied — {fmt(referralDiscount)} saved!</span>
//                     <button type="button" className="offer-remove" onClick={handleRemoveReferral}>✕ Remove</button>
//                   </div>
//                 )}
//               </section>

//               {/* Payment */}
//               <section className="form-section form-section--payment">
//                 <div className="form-section__header">
//                   <span className="form-section__num">4</span>
//                   <h2 className="form-section__title">Payment</h2>
//                 </div>
//                 <div className="payment-info">
//                   <div className="payment-info__row">
//                     <span className="payment-info__icon">🔒</span>
//                     <div>
//                       <p className="payment-info__title">Secure Payment via Razorpay</p>
//                       <p className="payment-info__sub">UPI · Cards · Net Banking · Wallets</p>
//                     </div>
//                   </div>
//                 </div>
//               </section>

//               <button type="submit" className={`pay-btn ${submitting ? "pay-btn--loading" : ""}`} disabled={submitting}>
//                 {submitting ? <><span className="spinner" />{payBtnLabel()}</> : payBtnLabel()}
//               </button>

//               <p className="submit-note">
//                 By placing this order you agree to our{" "}
//                 <a href="/terms" className="submit-note__link">Terms of Service</a> and{" "}
//                 <a href="/privacy" className="submit-note__link">Privacy Policy</a>.
//               </p>
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// const css = `
// @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Jost:wght@300;400;500;600&display=swap');
// :root{--c-primary:#2d6a4f;--c-primary-light:#40916c;--c-primary-dark:#1b4332;--c-accent:#d4a017;--c-bg:#f9f6f0;--c-surface:#ffffff;--c-text:#1c2b22;--c-muted:#5a7262;--c-border:#d4e6d5;--c-error:#c0392b;--c-error-bg:#fdf2f2;--c-success:#276749;--f-display:'Cormorant Garamond',Georgia,serif;--f-body:'Jost',sans-serif;--radius:14px;--radius-sm:8px;--ease:cubic-bezier(.4,0,.2,1);}
// *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
// body{font-family:var(--f-body);background:var(--c-bg);color:var(--c-text);}
// a{text-decoration:none;color:inherit;}
// .co-container{max-width:1100px;margin:0 auto;padding:0 24px;}
// .co-bc{background:var(--c-surface);border-bottom:1px solid var(--c-border);padding:12px 0;font-size:.78rem;color:var(--c-muted);}
// .co-bc .co-container{display:flex;align-items:center;gap:8px;}
// .co-bc a{color:var(--c-primary);}
// .co-bc__cur{color:var(--c-text);font-weight:600;}
// .co-header{background:linear-gradient(135deg,var(--c-primary-dark),#1e4d35);padding:40px 0 36px;position:relative;overflow:hidden;}
// .co-header::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 100% at 90% 50%,rgba(64,145,108,.18),transparent 60%);}
// .co-header__title{font-size:clamp(2rem,4vw,2.8rem);font-weight:600;color:#fff;margin-bottom:6px;}
// .co-header__sub{font-size:.88rem;color:rgba(255,255,255,.58);font-weight:300;}
// .stepbar{display:flex;align-items:center;padding:28px 0 32px;gap:0;}
// .step{display:flex;align-items:center;gap:10px;}
// .step__circle{width:34px;height:34px;border-radius:50%;border:2px solid var(--c-border);background:var(--c-surface);display:flex;align-items:center;justify-content:center;font-size:.82rem;font-weight:700;color:var(--c-muted);transition:all .3s var(--ease);flex-shrink:0;}
// .step__label{font-size:.78rem;font-weight:600;color:var(--c-muted);letter-spacing:.04em;white-space:nowrap;}
// .step--done .step__circle{background:var(--c-primary);border-color:var(--c-primary);color:#fff;}
// .step--done .step__label{color:var(--c-primary);}
// .step--active .step__circle{background:var(--c-primary-dark);border-color:var(--c-primary-dark);color:#fff;box-shadow:0 0 0 4px rgba(45,106,79,.18);}
// .step--active .step__label{color:var(--c-primary-dark);font-weight:700;}
// .step__line{flex:1;height:2px;background:var(--c-border);margin:0 12px;min-width:32px;transition:background .3s;}
// .step__line--done{background:var(--c-primary);}
// .co-page{min-height:100vh;}
// .co-body{padding-bottom:72px;}
// .co-layout{display:grid;grid-template-columns:1fr;gap:32px;align-items:start;}
// .co-form{display:flex;flex-direction:column;gap:20px;}
// .form-section{background:var(--c-surface);border:1px solid var(--c-border);border-radius:var(--radius);padding:28px 32px;animation:secIn .5s var(--ease) both;}
// @keyframes secIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
// .form-section__header{display:flex;align-items:center;gap:12px;margin-bottom:24px;padding-bottom:16px;border-bottom:1px solid var(--c-border);}
// .form-section__num{width:28px;height:28px;border-radius:50%;background:var(--c-primary);color:#fff;font-size:.78rem;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
// .form-section__title{font-size:1.3rem;font-weight:600;color:var(--c-primary-dark);}
// .form-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px 20px;}
// .field{display:flex;flex-direction:column;gap:6px;}
// .field--full,.field:has(.field--full),.field:has(.textarea){grid-column:1/-1;}
// .field__label{font-size:.78rem;font-weight:600;letter-spacing:.04em;color:var(--c-text);}
// .field__req{color:var(--c-error);margin-left:2px;}
// .field__hint{font-size:.72rem;color:var(--c-muted);}
// .field__error{font-size:.72rem;color:var(--c-error);display:flex;align-items:center;gap:4px;}
// .field__error::before{content:'⚠';font-size:.7rem;}
// .input,.textarea,.select{font-family:var(--f-body);font-size:.9rem;color:var(--c-text);padding:11px 14px;border:1.5px solid var(--c-border);border-radius:var(--radius-sm);background:var(--c-bg);outline:none;width:100%;transition:border-color .22s,box-shadow .22s,background .22s;}
// .input:focus,.textarea:focus,.select:focus{border-color:var(--c-primary-light);box-shadow:0 0 0 3px rgba(64,145,108,.13);background:var(--c-surface);}
// .input--error{border-color:var(--c-error);background:var(--c-error-bg);}
// .textarea{resize:vertical;min-height:80px;}
// .select{appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%235a7262' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 13px center;background-size:12px;cursor:pointer;}
// .input-prefix-wrap{position:relative;display:flex;align-items:center;}
// .input-prefix{position:absolute;left:13px;font-size:.85rem;font-weight:600;color:var(--c-muted);pointer-events:none;z-index:1;}
// .input--prefix{padding-left:44px;}
// .save-row{padding:4px 0;}
// .checkbox-label{display:flex;align-items:center;gap:11px;cursor:pointer;}
// .checkbox{display:none;}
// .checkbox__box{width:20px;height:20px;border-radius:5px;flex-shrink:0;border:2px solid var(--c-border);background:var(--c-surface);transition:all .22s var(--ease);position:relative;}
// .checkbox:checked~.checkbox__box{background:var(--c-primary);border-color:var(--c-primary);}
// .checkbox:checked~.checkbox__box::after{content:'✓';position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:.72rem;font-weight:700;color:#fff;}
// .checkbox__text{font-size:.84rem;color:var(--c-muted);}
// .form-section--offers{background:linear-gradient(135deg,rgba(212,160,23,.03),var(--c-surface));}
// .offer-banner{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:16px;border-radius:var(--radius-sm);margin-bottom:14px;}
// .offer-banner--loyalty{background:linear-gradient(135deg,rgba(45,106,79,.08),rgba(45,106,79,.04));border:1.5px solid rgba(45,106,79,.25);}
// .offer-banner__left{display:flex;align-items:flex-start;gap:12px;}
// .offer-banner__icon{font-size:1.4rem;flex-shrink:0;}
// .offer-banner__title{font-size:.9rem;font-weight:700;color:var(--c-primary-dark);margin-bottom:2px;}
// .offer-banner__sub{font-size:.76rem;color:var(--c-muted);}
// .offer-banner__btn{font-family:var(--f-body);font-size:.78rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:8px 18px;border-radius:100px;border:none;background:var(--c-primary);color:#fff;cursor:pointer;white-space:nowrap;transition:background .22s;}
// .offer-banner__btn:hover:not(:disabled){background:var(--c-primary-dark);}
// .offer-banner__btn:disabled{opacity:.7;cursor:wait;}
// .offer-applied{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-radius:var(--radius-sm);margin-bottom:14px;font-size:.84rem;font-weight:600;}
// .offer-applied--loyalty{background:rgba(45,106,79,.08);color:var(--c-primary);}
// .offer-applied--referral{background:rgba(212,160,23,.08);color:#8a6200;}
// .offer-remove{background:none;border:none;cursor:pointer;font-size:.76rem;color:var(--c-muted);font-family:var(--f-body);}
// .offer-remove:hover{color:var(--c-error);}
// .purchase-progress{padding:16px;background:var(--c-bg);border-radius:var(--radius-sm);border:1px solid var(--c-border);margin-bottom:14px;}
// .pp-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;}
// .pp-title{font-size:.84rem;font-weight:600;color:var(--c-text);}
// .pp-count{font-size:.8rem;font-weight:700;color:var(--c-primary);}
// .pp-bar{height:8px;background:var(--c-border);border-radius:100px;overflow:hidden;margin-bottom:8px;}
// .pp-bar__fill{height:100%;background:linear-gradient(90deg,var(--c-primary-light),var(--c-primary));border-radius:100px;transition:width .6s var(--ease);}
// .pp-hint{font-size:.72rem;color:var(--c-muted);}
// .referral-input-wrap{margin-top:4px;}
// .referral-label{font-size:.8rem;font-weight:600;color:var(--c-text);margin-bottom:8px;}
// .referral-row{display:flex;gap:10px;}
// .referral-input{flex:1;text-transform:uppercase;letter-spacing:.06em;}
// .referral-apply-btn{font-family:var(--f-body);font-size:.8rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:0 20px;border-radius:var(--radius-sm);border:none;background:var(--c-primary);color:#fff;cursor:pointer;white-space:nowrap;transition:background .22s;}
// .referral-apply-btn:hover:not(:disabled){background:var(--c-primary-dark);}
// .referral-apply-btn:disabled{opacity:.6;cursor:not-allowed;}
// .referral-msg{font-size:.76rem;margin-top:6px;font-weight:500;}
// .referral-msg--success{color:var(--c-success);}
// .referral-msg--error{color:var(--c-error);}
// .form-section--payment{background:linear-gradient(135deg,rgba(45,106,79,.03),var(--c-surface));}
// .payment-info{display:flex;flex-direction:column;gap:16px;}
// .payment-info__row{display:flex;align-items:flex-start;gap:14px;}
// .payment-info__icon{font-size:1.8rem;line-height:1;flex-shrink:0;}
// .payment-info__title{font-size:.96rem;font-weight:600;color:var(--c-primary-dark);margin-bottom:3px;}
// .payment-info__sub{font-size:.8rem;color:var(--c-muted);font-weight:300;}
// .pay-btn{width:100%;font-family:var(--f-body);font-size:.92rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:17px;border-radius:100px;border:none;cursor:pointer;background:var(--c-primary);color:#fff;box-shadow:0 6px 24px rgba(45,106,79,.32);display:flex;align-items:center;justify-content:center;gap:10px;transition:background .22s,transform .22s,box-shadow .22s;animation:secIn .5s var(--ease) .28s both;}
// .pay-btn:hover:not(:disabled){background:var(--c-primary-dark);transform:translateY(-2px);box-shadow:0 10px 32px rgba(45,106,79,.4);}
// .pay-btn:disabled{opacity:.75;cursor:wait;transform:none;}
// .pay-btn--loading{background:var(--c-primary-dark);}
// .spinner{width:18px;height:18px;border-radius:50%;border:2.5px solid rgba(255,255,255,.3);border-top-color:#fff;animation:spin .7s linear infinite;}
// @keyframes spin{to{transform:rotate(360deg)}}
// .submit-note{text-align:center;font-size:.74rem;color:var(--c-muted);margin-top:4px;}
// .submit-note__link{color:var(--c-primary);text-decoration:underline;}
// .order-summary{background:var(--c-surface);border:1px solid var(--c-border);border-radius:var(--radius);overflow:hidden;top:24px;animation:secIn .5s var(--ease) .15s both;}
// .os-toggle{width:100%;display:flex;align-items:center;gap:10px;padding:18px 22px;background:var(--c-bg);border:none;border-bottom:1px solid var(--c-border);cursor:pointer;font-family:var(--f-body);transition:background .2s;}
// .os-toggle:hover{background:var(--c-border);}
// .os-toggle__label{flex:1;display:flex;align-items:center;gap:10px;font-size:.84rem;font-weight:700;color:var(--c-text);text-align:left;}
// .os-toggle__count{font-size:.7rem;background:var(--c-primary);color:#fff;padding:2px 8px;border-radius:100px;font-weight:600;}
// .os-toggle__total{font-size:1.2rem;font-weight:600;color:var(--c-primary-dark);}
// .os-toggle__arrow{font-size:.7rem;color:var(--c-muted);}
// .os-body{padding:20px 22px;}
// .os-items{display:flex;flex-direction:column;gap:14px;margin-bottom:4px;}
// .os-item{display:flex;align-items:center;gap:12px;}
// .os-item__img{width:48px;height:48px;border-radius:8px;flex-shrink:0;background:linear-gradient(135deg,#f0f7f2,#e8f5ec);display:flex;align-items:center;justify-content:center;font-size:1.5rem;position:relative;overflow:visible;}
// .os-item__qty{position:absolute;top:-6px;right:-6px;background:var(--c-primary);color:#fff;font-size:.6rem;font-weight:700;width:18px;height:18px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:2px solid var(--c-surface);}
// .os-item__info{flex:1;min-width:0;}
// .os-item__name{display:block;font-size:.86rem;font-weight:600;color:var(--c-text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
// .os-item__cat{display:block;font-size:.7rem;color:var(--c-muted);margin-top:2px;}
// .os-item__price{font-size:1rem;font-weight:600;color:var(--c-primary-dark);white-space:nowrap;}
// .os-divider{height:1px;background:var(--c-border);margin:16px 0;}
// .os-rows{display:flex;flex-direction:column;gap:10px;}
// .os-row{display:flex;justify-content:space-between;font-size:.84rem;color:var(--c-muted);}
// .os-row--green{color:var(--c-success);}
// .free-tag{background:rgba(45,106,79,.08);color:var(--c-primary);font-size:.68rem;font-weight:700;text-transform:uppercase;letter-spacing:.06em;padding:2px 8px;border-radius:100px;}
// .os-total{display:flex;justify-content:space-between;align-items:baseline;padding-top:4px;}
// .os-total>span:first-child{font-size:.86rem;font-weight:700;color:var(--c-text);}
// .os-total__val{font-size:1.5rem;font-weight:600;color:var(--c-primary-dark);}
// .os-note{margin-top:16px;font-size:.72rem;color:var(--c-muted);text-align:center;padding:10px 12px;background:var(--c-bg);border-radius:var(--radius-sm);}
// @media(max-width:992px){.co-layout{grid-template-columns:1fr;gap:24px;}.order-summary{position:static;width:100%;}}
// @media(max-width:768px){.co-layout{display:flex!important;flex-direction:column!important;}.co-container{padding:0 16px;}.form-section{padding:20px 16px;}.form-grid{grid-template-columns:1fr;gap:14px;}.co-header{padding:28px 0;}.stepbar{padding:20px 0;justify-content:space-between;}.step__label{display:none;}.step__circle{width:28px;height:28px;font-size:.7rem;}.step__line{margin:0 6px;}.pay-btn{padding:14px;font-size:.85rem;}.referral-row{flex-direction:column;}}
// @media(max-width:480px){.co-container{padding:0 12px;}.co-header__title{font-size:1.6rem;}.form-section__title{font-size:1.1rem;}.input,.textarea,.select{font-size:.85rem;padding:10px 12px;}}
// `;
























import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import {
  createRazorpayOrder,
  verifyRazorpayPayment,
  placeOrderAPI,
} from "../services/orderService";
import {
  applyReferralCodeAPI,
  applyLoyaltyDiscountAPI,
  removeLoyaltyDiscountAPI,
  getMyReferralInfoAPI,
} from "../services/referralService";

const STORAGE_KEY = "sanjivani_checkout_info";
const fmt = (n) => "₹" + Number(n).toLocaleString("en-IN");

const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
  "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh", "Delhi", "Jammu and Kashmir",
  "Ladakh", "Lakshadweep", "Puducherry",
];

const loadRazorpayScript = () =>
  new Promise((resolve) => {
    if (document.getElementById("razorpay-sdk")) { resolve(true); return; }
    const script = document.createElement("script");
    script.id = "razorpay-sdk";
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

function validate(fields) {
  const errors = {};
  if (!fields.name.trim()) errors.name = "Full name is required.";
  else if (fields.name.trim().length < 3) errors.name = "Name must be at least 3 characters.";
  if (!fields.phone.trim()) errors.phone = "Phone number is required.";
  else if (!/^[6-9]\d{9}$/.test(fields.phone.trim())) errors.phone = "Enter a valid 10-digit Indian mobile number.";
  if (!fields.email.trim()) errors.email = "Email address is required.";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email.trim())) errors.email = "Enter a valid email address.";
  if (!fields.address.trim()) errors.address = "Street address is required.";
  else if (fields.address.trim().length < 10) errors.address = "Please enter a complete address.";
  if (!fields.city.trim()) errors.city = "City is required.";
  if (!fields.state) errors.state = "Please select your state.";
  if (!fields.pincode.trim()) errors.pincode = "Pincode is required.";
  else if (!/^\d{6}$/.test(fields.pincode.trim())) errors.pincode = "Enter a valid 6-digit pincode.";
  return errors;
}

const STEPS = ["Cart", "Delivery", "Payment"];

function StepBar({ current }) {
  return (
    <div className="stepbar">
      {STEPS.map((s, i) => (
        <React.Fragment key={s}>
          <div className={`step ${i < current ? "step--done" : i === current ? "step--active" : ""}`}>
            <div className="step__circle">{i < current ? <span>✓</span> : <span>{i + 1}</span>}</div>
            <span className="step__label">{s}</span>
          </div>
          {i < STEPS.length - 1 && <div className={`step__line ${i < current ? "step__line--done" : ""}`} />}
        </React.Fragment>
      ))}
    </div>
  );
}

function Field({ label, id, error, required, children, hint }) {
  return (
    <div className={`field ${error ? "field--error" : ""}`}>
      <label className="field__label" htmlFor={id}>
        {label}{required && <span className="field__req">*</span>}
      </label>
      {children}
      {hint && !error && <p className="field__hint">{hint}</p>}
      {error && <p className="field__error">{error}</p>}
    </div>
  );
}

function OrderSummary({ items, subtotal, referralDiscount, loyaltyDiscount, shipping, total, coupon }) {
  const [open, setOpen] = useState(true);

  return (
    <aside className="order-summary">
      <button className="os-toggle" onClick={() => setOpen(o => !o)}>
        <span className="os-toggle__label">
          🛒 Order Summary
          <span className="os-toggle__count">{items.length} item{items.length !== 1 ? "s" : ""}</span>
        </span>
        <span className="os-toggle__total">{fmt(total)}</span>
        <span className="os-toggle__arrow">{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div className="os-body">
          <div className="os-items">
            {items.map(item => (
              <div className="os-item" key={item.id}>
                <div className="os-item__img">
                  {(() => {
                    const src = Array.isArray(item.emoji) ? item.emoji[0] : item.emoji;
                    const str = typeof src === "string" ? src : "";
                    return str.startsWith("http")
                      ? <img src={str} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }} />
                      : <span>{str || "🌿"}</span>;
                  })()}
                  <span className="os-item__qty">{item.quantity}</span>
                </div>
                <div className="os-item__info">
                  <span className="os-item__name">{item.name}</span>
                  {item.category && <span className="os-item__cat">{item.category}</span>}
                </div>
                <span className="os-item__price">{fmt(item.price * item.quantity)}</span>
              </div>
            ))}
          </div>

          <div className="os-divider" />

          <div className="os-rows">
            <div className="os-row"><span>Subtotal</span><span>{fmt(subtotal)}</span></div>
            {coupon?.discountAmount > 0 && (
              <div className="os-row os-row--green">
                <span>Coupon ({coupon.code})</span>
                <span>−{fmt(coupon.discountAmount)}</span>
              </div>
            )}
            {referralDiscount > 0 && (
              <div className="os-row os-row--green">
                <span>Referral Discount (10%)</span>
                <span>−{fmt(referralDiscount)}</span>
              </div>
            )}
            {loyaltyDiscount > 0 && (
              <div className="os-row os-row--green">
                <span>Loyalty Offer (50% off)</span>
                <span>−{fmt(loyaltyDiscount)}</span>
              </div>
            )}
            <div className="os-row">
              <span>Shipping</span>
              <span>{shipping === 0 ? <span className="free-tag">FREE</span> : fmt(shipping)}</span>
            </div>
          </div>

          <div className="os-divider" />

          <div className="os-total">
            <span>Total</span>
            <span className="os-total__val">{fmt(total)}</span>
          </div>
          <p className="os-note">🔒 All transactions are secured & encrypted</p>
        </div>
      )}
    </aside>
  );
}

const EMPTY_FORM = {
  name: "", phone: "", email: "",
  address: "", city: "", state: "", pincode: "",
  saveInfo: true,
};

export default function Checkout() {
  const navigate = useNavigate();
  const { items, subtotal, shipping, coupon, itemCount, clearCart } = useCart();

  const [fields, setFields] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [payStep, setPayStep] = useState("");
  const [orderCompleted, setOrderCompleted] = useState(false);

  // Referral
  const [referralCode, setReferralCode] = useState("");
  const [referralApplied, setReferralApplied] = useState(false);
  const [referralDiscount, setReferralDiscount] = useState(0);
  const [referralMsg, setReferralMsg] = useState({ text: "", type: "" });
  const [referralLoading, setReferralLoading] = useState(false);

  // Loyalty
  const [loyaltyInfo, setLoyaltyInfo] = useState(null);
  const [loyaltyApplied, setLoyaltyApplied] = useState(false);
  const [loyaltyDiscount, setLoyaltyDiscount] = useState(0);
  const [loyaltyLoading, setLoyaltyLoading] = useState(false);

  const couponDiscount = coupon?.discountAmount || 0;
  const total = Math.max(0, subtotal - couponDiscount - referralDiscount - loyaltyDiscount + shipping);

  // Load loyalty info
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;
    getMyReferralInfoAPI().then(result => {
      if (result?.success) setLoyaltyInfo(result.data);
    });
  }, []);

  // Restore saved info
  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) setFields(prev => ({ ...prev, ...JSON.parse(saved), saveInfo: true }));
    } catch { }
  }, []);

  // Redirect if cart empty
  useEffect(() => {
    if (itemCount === 0 && !orderCompleted) navigate("/products");
  }, [itemCount, orderCompleted, navigate]);

  // Validate on touch
  useEffect(() => {
    if (Object.keys(touched).length > 0) setErrors(validate(fields));
  }, [fields, touched]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFields(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };
  const handleBlur = (e) => setTouched(prev => ({ ...prev, [e.target.name]: true }));

  // Apply referral code
  const handleApplyReferral = async () => {
    if (!referralCode.trim()) return;
    setReferralLoading(true);
    setReferralMsg({ text: "", type: "" });
    const result = await applyReferralCodeAPI(referralCode.trim());
    setReferralLoading(false);
    if (result?.success) {
      const disc = Math.round(subtotal * 0.10);
      setReferralDiscount(disc);
      setReferralApplied(true);
      setReferralMsg({ text: `✓ Referral applied! You save ${fmt(disc)}`, type: "success" });
    } else {
      setReferralMsg({ text: result?.message || "Invalid referral code.", type: "error" });
    }
  };

  const handleRemoveReferral = () => {
    setReferralApplied(false);
    setReferralDiscount(0);
    setReferralCode("");
    setReferralMsg({ text: "", type: "" });
  };

  // Toggle loyalty discount (checkbox)
  const handleLoyaltyToggle = async (e) => {
    const checked = e.target.checked;

    if (checked) {
      setLoyaltyLoading(true);
      const result = await applyLoyaltyDiscountAPI();
      setLoyaltyLoading(false);
      if (result?.success) {
        const paidItems = items.filter(i => !i.isFree);
        const cheapest = [...paidItems].sort((a, b) => a.price - b.price)[0];
        const disc = cheapest ? Math.round(cheapest.price * cheapest.quantity * 0.50) : 0;
        setLoyaltyDiscount(disc);
        setLoyaltyApplied(true);
      }
    } else {
      setLoyaltyLoading(true);
      await removeLoyaltyDiscountAPI();
      setLoyaltyLoading(false);
      setLoyaltyApplied(false);
      setLoyaltyDiscount(0);
    }
  };

  // Payment flow
  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    const allTouched = Object.fromEntries(Object.keys(fields).map(k => [k, true]));
    setTouched(allTouched);
    const errs = validate(fields);
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      document.querySelector(".field--error")?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (fields.saveInfo) {
      try { const { saveInfo, ...toSave } = fields; localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave)); } catch { }
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }

    setSubmitting(true);
    setPayStep("creating");

    try {
      const sdkLoaded = await loadRazorpayScript();
      if (!sdkLoaded) {
        alert("Failed to load Razorpay. Please try again.");
        setSubmitting(false); setPayStep(""); return;
      }

      const orderResult = await createRazorpayOrder(total);
      if (!orderResult?.success) {
        alert(orderResult?.message || "Failed to initiate payment.");
        setSubmitting(false); setPayStep(""); return;
      }

      const { orderId: razorpayOrderId, amount, keyId } = orderResult.data;
      setPayStep("redirecting");

      await new Promise((resolve, reject) => {
        const options = {
          key: keyId, amount, currency: "INR",
          name: "Sanjivani Ayurveda",
          description: `Order of ${itemCount} item${itemCount !== 1 ? "s" : ""}`,
          order_id: razorpayOrderId,
          prefill: {
            name: fields.name.trim(),
            email: fields.email.trim(),
            contact: `+91${fields.phone.trim()}`,
          },
          theme: { color: "#2d6a4f" },
          modal: { ondismiss: () => reject(new Error("PAYMENT_CANCELLED")) },
          handler: async (response) => {
            try {
              setPayStep("placing");
              const verifyResult = await verifyRazorpayPayment({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              });
              if (!verifyResult?.success) {
                alert("Payment verification failed. Contact support: " + response.razorpay_payment_id);
                reject(new Error("VERIFICATION_FAILED")); return;
              }

              const placeResult = await placeOrderAPI({
                shippingAddress: {
                  fullName: fields.name.trim(),
                  phone: fields.phone.trim(),
                  addressLine1: fields.address.trim(),
                  city: fields.city.trim(),
                  state: fields.state,
                  pincode: fields.pincode.trim(),
                },
                paymentMethod: "razorpay",
                razorpayOrderId: response.razorpay_order_id,
                razorpayPaymentId: response.razorpay_payment_id,
                useReferralDiscount: referralApplied,
                useLoyaltyDiscount: loyaltyApplied,
              });

              if (!placeResult?.success) {
                alert(placeResult?.message || "Order placement failed. Contact support.");
                reject(new Error("ORDER_PLACEMENT_FAILED")); return;
              }

              await clearCart();
              const orderId = placeResult.data?.order?.id || placeResult.data?.order?._id;
              setOrderCompleted(true);
              resolve(orderId);
            } catch (err) { reject(err); }
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.on("payment.failed", (r) => reject(new Error(`PAYMENT_FAILED: ${r.error?.description || "Unknown"}`)));
        rzp.open();
      })
        .then((orderId) => navigate(`/order-confirmation/${orderId}`))
        .catch((err) => {
          if (err.message !== "PAYMENT_CANCELLED" && err.message?.startsWith("PAYMENT_FAILED")) {
            alert("Payment failed: " + err.message.replace("PAYMENT_FAILED: ", ""));
          }
          setSubmitting(false); setPayStep("");
        });

    } catch (err) {
      console.error("Checkout error:", err);
      alert("Something went wrong. Please try again.");
      setSubmitting(false); setPayStep("");
    }
  }, [fields, total, itemCount, clearCart, navigate, referralApplied, loyaltyApplied]);

  const inputClass = (name) => `input ${errors[name] && touched[name] ? "input--error" : ""}`;
  const payBtnLabel = () => {
    if (!submitting) return `🔒 Pay ${fmt(total)} Now`;
    if (payStep === "creating") return "Creating order…";
    if (payStep === "redirecting") return "Opening Razorpay…";
    if (payStep === "placing") return "Placing your order…";
    return "Processing…";
  };

  return (
    <>
      <style>{css}</style>
      <div className="co-page">

        <div className="co-bc">
          <div className="co-container">
            <Link to="/">Home</Link><span>›</span>
            <Link to="/cart">Cart</Link><span>›</span>
            <span className="co-bc__cur">Checkout</span>
          </div>
        </div>

        <div className="co-header">
          <div className="co-container">
            <h1 className="co-header__title">Checkout</h1>
            <p className="co-header__sub">Almost there — complete your order below</p>
          </div>
        </div>

        <div className="co-container co-body">
          <StepBar current={1} />

          <div className="co-layout">
            <OrderSummary
              items={items} subtotal={subtotal}
              referralDiscount={referralDiscount} loyaltyDiscount={loyaltyDiscount}
              shipping={shipping} total={total} coupon={coupon}
            />

            <form className="co-form" onSubmit={handleSubmit} noValidate>

              {/* Personal Info */}
              <section className="form-section">
                <div className="form-section__header">
                  <span className="form-section__num">1</span>
                  <h2 className="form-section__title">Personal Information</h2>
                </div>
                <div className="form-grid">
                  <Field label="Full Name" id="name" error={touched.name && errors.name} required>
                    <input className={inputClass("name")} id="name" name="name" type="text"
                      placeholder="Priya Sharma" value={fields.name}
                      onChange={handleChange} onBlur={handleBlur} autoComplete="name" />
                  </Field>
                  <Field label="Mobile Number" id="phone" error={touched.phone && errors.phone} required hint="10-digit Indian mobile number">
                    <div className="input-prefix-wrap">
                      <span className="input-prefix">+91</span>
                      <input className={inputClass("phone") + " input--prefix"} id="phone" name="phone"
                        type="tel" placeholder="98765 43210" value={fields.phone}
                        onChange={handleChange} onBlur={handleBlur} maxLength={10} autoComplete="tel" />
                    </div>
                  </Field>
                  <Field label="Email Address" id="email" error={touched.email && errors.email} required hint="Order confirmation will be sent here">
                    <input className={inputClass("email") + " field--full"} id="email" name="email"
                      type="email" placeholder="priya@example.com" value={fields.email}
                      onChange={handleChange} onBlur={handleBlur} autoComplete="email" />
                  </Field>
                </div>
              </section>

              {/* Delivery Address */}
              <section className="form-section">
                <div className="form-section__header">
                  <span className="form-section__num">2</span>
                  <h2 className="form-section__title">Delivery Address</h2>
                </div>
                <div className="form-grid">
                  <Field label="Street Address" id="address" error={touched.address && errors.address} required>
                    <textarea className={inputClass("address") + " textarea field--full"} id="address" name="address"
                      placeholder="House no., Street name, Landmark…" value={fields.address}
                      onChange={handleChange} onBlur={handleBlur} rows={3} autoComplete="street-address" />
                  </Field>
                  <Field label="City / District" id="city" error={touched.city && errors.city} required>
                    <input className={inputClass("city")} id="city" name="city" type="text"
                      placeholder="Ahmedabad" value={fields.city}
                      onChange={handleChange} onBlur={handleBlur} autoComplete="address-level2" />
                  </Field>
                  <Field label="State" id="state" error={touched.state && errors.state} required>
                    <select className={inputClass("state") + " select"} id="state" name="state"
                      value={fields.state} onChange={handleChange} onBlur={handleBlur}>
                      <option value="">Select state…</option>
                      {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </Field>
                  <Field label="PIN Code" id="pincode" error={touched.pincode && errors.pincode} required>
                    <input className={inputClass("pincode")} id="pincode" name="pincode" type="text"
                      placeholder="380001" value={fields.pincode}
                      onChange={handleChange} onBlur={handleBlur} maxLength={6} autoComplete="postal-code" />
                  </Field>
                </div>
              </section>

              {/* Save info */}
              <div className="save-row">
                <label className="checkbox-label">
                  <input type="checkbox" name="saveInfo" checked={fields.saveInfo} onChange={handleChange} className="checkbox" />
                  <span className="checkbox__box" />
                  <span className="checkbox__text">Save my details for faster checkout next time</span>
                </label>
              </div>

              {/* Offers */}
              <section className="form-section form-section--offers">
                <div className="form-section__header">
                  <span className="form-section__num">3</span>
                  <h2 className="form-section__title">Offers & Discounts</h2>
                </div>

                {/* Loyalty offer — checkbox, only shown once unlocked (4 past items bought) */}
              
                {/* {loyaltyInfo?.loyaltyDiscountUnlocked && (
                  <div className="offer-banner offer-banner--loyalty">
                    <label className="loyalty-checkbox-label">
                      <input
                        type="checkbox"
                        className="checkbox"
                        checked={loyaltyApplied}
                        onChange={handleLoyaltyToggle}
                        disabled={loyaltyLoading}
                      />
                      <span className="checkbox__box" />
                      <div className="loyalty-checkbox-text">
                        <p className="offer-banner__title">🎁 Apply 50% off your cheapest item</p>
                        <p className="offer-banner__sub">
                          {loyaltyApplied
                            ? `Applied — you save ${fmt(loyaltyDiscount)}!`
                            : "You've bought 4 items — check this box to use your reward"}
                        </p>
                      </div>
                      {loyaltyLoading && <span className="loyalty-spinner" />}
                    </label>
                  </div>
                )} */}

                {/* Purchase counter progress (shown while still locked) */}

                {/* {loyaltyInfo && !loyaltyInfo.loyaltyDiscountUnlocked && (
                  <div className="purchase-progress">
                    <div className="pp-header">
                      <span className="pp-title">🌿 Loyalty Progress</span>
                      <span className="pp-count">{loyaltyInfo.purchaseCounter}/4 items</span>
                    </div>
                    <div className="pp-bar">
                      <div className="pp-bar__fill" style={{ width: `${Math.min((loyaltyInfo.purchaseCounter / 4) * 100, 100)}%` }} />
                    </div>
                    <p className="pp-hint">
                      Buy {4 - loyaltyInfo.purchaseCounter} more item{4 - loyaltyInfo.purchaseCounter !== 1 ? "s" : ""} to unlock 50% off your next purchase!
                    </p>
                  </div>
                )} */}

                {/* Referral code */}
                {!referralApplied ? (
                  <div className="referral-input-wrap">
                    <p className="referral-label">Have a referral code? Get 10% off</p>
                    <div className="referral-row">
                      <input
                        className="input referral-input"
                        type="text"
                        placeholder="Enter referral code (e.g. SAYPRIY3A)"
                        value={referralCode}
                        onChange={e => { setReferralCode(e.target.value.toUpperCase()); setReferralMsg({ text: "", type: "" }); }}
                        maxLength={12}
                      />
                      <button type="button" className="referral-apply-btn"
                        onClick={handleApplyReferral}
                        disabled={referralLoading || !referralCode.trim()}>
                        {referralLoading ? "…" : "Apply"}
                      </button>
                    </div>
                    {referralMsg.text && (
                      <p className={`referral-msg referral-msg--${referralMsg.type}`}>{referralMsg.text}</p>
                    )}
                  </div>
                ) : (
                  <div className="offer-applied offer-applied--referral">
                    <span>🎉 Referral applied — {fmt(referralDiscount)} saved!</span>
                    <button type="button" className="offer-remove" onClick={handleRemoveReferral}>✕ Remove</button>
                  </div>
                )}
              </section>

              {/* Payment */}
              <section className="form-section form-section--payment">
                <div className="form-section__header">
                  <span className="form-section__num">4</span>
                  <h2 className="form-section__title">Payment</h2>
                </div>
                <div className="payment-info">
                  <div className="payment-info__row">
                    <span className="payment-info__icon">🔒</span>
                    <div>
                      <p className="payment-info__title">Secure Payment via Razorpay</p>
                      <p className="payment-info__sub">UPI · Cards · Net Banking · Wallets</p>
                    </div>
                  </div>
                </div>
              </section>

              <button type="submit" className={`pay-btn ${submitting ? "pay-btn--loading" : ""}`} disabled={submitting}>
                {submitting ? <><span className="spinner" />{payBtnLabel()}</> : payBtnLabel()}
              </button>

              <p className="submit-note">
                By placing this order you agree to our{" "}
                <a href="/terms" className="submit-note__link">Terms of Service</a> and{" "}
                <a href="/privacy" className="submit-note__link">Privacy Policy</a>.
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

const css = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400&family=Jost:wght@300;400;500;600&display=swap');
:root{--c-primary:#2d6a4f;--c-primary-light:#40916c;--c-primary-dark:#1b4332;--c-accent:#d4a017;--c-bg:#f9f6f0;--c-surface:#ffffff;--c-text:#1c2b22;--c-muted:#5a7262;--c-border:#d4e6d5;--c-error:#c0392b;--c-error-bg:#fdf2f2;--c-success:#276749;--f-display:'Cormorant Garamond',Georgia,serif;--f-body:'Jost',sans-serif;--radius:14px;--radius-sm:8px;--ease:cubic-bezier(.4,0,.2,1);}
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
body{font-family:var(--f-body);background:var(--c-bg);color:var(--c-text);}
a{text-decoration:none;color:inherit;}
.co-container{max-width:1100px;margin:0 auto;padding:0 24px;}
.co-bc{background:var(--c-surface);border-bottom:1px solid var(--c-border);padding:12px 0;font-size:.78rem;color:var(--c-muted);}
.co-bc .co-container{display:flex;align-items:center;gap:8px;}
.co-bc a{color:var(--c-primary);}
.co-bc__cur{color:var(--c-text);font-weight:600;}
.co-header{background:linear-gradient(135deg,var(--c-primary-dark),#1e4d35);padding:40px 0 36px;position:relative;overflow:hidden;}
.co-header::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 100% at 90% 50%,rgba(64,145,108,.18),transparent 60%);}
.co-header__title{font-size:clamp(2rem,4vw,2.8rem);font-weight:600;color:#fff;margin-bottom:6px;}
.co-header__sub{font-size:.88rem;color:rgba(255,255,255,.58);font-weight:300;}
.stepbar{display:flex;align-items:center;padding:28px 0 32px;gap:0;}
.step{display:flex;align-items:center;gap:10px;}
.step__circle{width:34px;height:34px;border-radius:50%;border:2px solid var(--c-border);background:var(--c-surface);display:flex;align-items:center;justify-content:center;font-size:.82rem;font-weight:700;color:var(--c-muted);transition:all .3s var(--ease);flex-shrink:0;}
.step__label{font-size:.78rem;font-weight:600;color:var(--c-muted);letter-spacing:.04em;white-space:nowrap;}
.step--done .step__circle{background:var(--c-primary);border-color:var(--c-primary);color:#fff;}
.step--done .step__label{color:var(--c-primary);}
.step--active .step__circle{background:var(--c-primary-dark);border-color:var(--c-primary-dark);color:#fff;box-shadow:0 0 0 4px rgba(45,106,79,.18);}
.step--active .step__label{color:var(--c-primary-dark);font-weight:700;}
.step__line{flex:1;height:2px;background:var(--c-border);margin:0 12px;min-width:32px;transition:background .3s;}
.step__line--done{background:var(--c-primary);}
.co-page{min-height:100vh;}
.co-body{padding-bottom:72px;}
.co-layout{display:grid;grid-template-columns:1fr;gap:32px;align-items:start;}
.co-form{display:flex;flex-direction:column;gap:20px;}
.form-section{background:var(--c-surface);border:1px solid var(--c-border);border-radius:var(--radius);padding:28px 32px;animation:secIn .5s var(--ease) both;}
@keyframes secIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
.form-section__header{display:flex;align-items:center;gap:12px;margin-bottom:24px;padding-bottom:16px;border-bottom:1px solid var(--c-border);}
.form-section__num{width:28px;height:28px;border-radius:50%;background:var(--c-primary);color:#fff;font-size:.78rem;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
.form-section__title{font-size:1.3rem;font-weight:600;color:var(--c-primary-dark);}
.form-grid{display:grid;grid-template-columns:1fr 1fr;gap:18px 20px;}
.field{display:flex;flex-direction:column;gap:6px;}
.field--full,.field:has(.field--full),.field:has(.textarea){grid-column:1/-1;}
.field__label{font-size:.78rem;font-weight:600;letter-spacing:.04em;color:var(--c-text);}
.field__req{color:var(--c-error);margin-left:2px;}
.field__hint{font-size:.72rem;color:var(--c-muted);}
.field__error{font-size:.72rem;color:var(--c-error);display:flex;align-items:center;gap:4px;}
.field__error::before{content:'⚠';font-size:.7rem;}
.input,.textarea,.select{font-family:var(--f-body);font-size:.9rem;color:var(--c-text);padding:11px 14px;border:1.5px solid var(--c-border);border-radius:var(--radius-sm);background:var(--c-bg);outline:none;width:100%;transition:border-color .22s,box-shadow .22s,background .22s;}
.input:focus,.textarea:focus,.select:focus{border-color:var(--c-primary-light);box-shadow:0 0 0 3px rgba(64,145,108,.13);background:var(--c-surface);}
.input--error{border-color:var(--c-error);background:var(--c-error-bg);}
.textarea{resize:vertical;min-height:80px;}
.select{appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%235a7262' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 13px center;background-size:12px;cursor:pointer;}
.input-prefix-wrap{position:relative;display:flex;align-items:center;}
.input-prefix{position:absolute;left:13px;font-size:.85rem;font-weight:600;color:var(--c-muted);pointer-events:none;z-index:1;}
.input--prefix{padding-left:44px;}
.save-row{padding:4px 0;}
.checkbox-label{display:flex;align-items:center;gap:11px;cursor:pointer;}
.checkbox{display:none;}
.checkbox__box{width:20px;height:20px;border-radius:5px;flex-shrink:0;border:2px solid var(--c-border);background:var(--c-surface);transition:all .22s var(--ease);position:relative;}
.checkbox:checked~.checkbox__box{background:var(--c-primary);border-color:var(--c-primary);}
.checkbox:checked~.checkbox__box::after{content:'✓';position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:.72rem;font-weight:700;color:#fff;}
.checkbox__text{font-size:.84rem;color:var(--c-muted);}
.form-section--offers{background:linear-gradient(135deg,rgba(212,160,23,.03),var(--c-surface));}
.offer-banner{display:flex;align-items:center;justify-content:space-between;gap:14px;padding:16px;border-radius:var(--radius-sm);margin-bottom:14px;}
.offer-banner--loyalty{background:linear-gradient(135deg,rgba(45,106,79,.08),rgba(45,106,79,.04));border:1.5px solid rgba(45,106,79,.25);}
.loyalty-checkbox-label{display:flex;align-items:flex-start;gap:12px;cursor:pointer;width:100%;}
.loyalty-checkbox-text{flex:1;}
.loyalty-spinner{width:16px;height:16px;border-radius:50%;border:2px solid rgba(45,106,79,.2);border-top-color:var(--c-primary);animation:spin .7s linear infinite;flex-shrink:0;margin-top:2px;}
@keyframes spin{to{transform:rotate(360deg)}}
.offer-banner__title{font-size:.9rem;font-weight:700;color:var(--c-primary-dark);margin-bottom:2px;}
.offer-banner__sub{font-size:.76rem;color:var(--c-muted);}
.offer-applied{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-radius:var(--radius-sm);margin-bottom:14px;font-size:.84rem;font-weight:600;}
.offer-applied--referral{background:rgba(212,160,23,.08);color:#8a6200;}
.offer-remove{background:none;border:none;cursor:pointer;font-size:.76rem;color:var(--c-muted);font-family:var(--f-body);}
.offer-remove:hover{color:var(--c-error);}
.purchase-progress{padding:16px;background:var(--c-bg);border-radius:var(--radius-sm);border:1px solid var(--c-border);margin-bottom:14px;}
.pp-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;}
.pp-title{font-size:.84rem;font-weight:600;color:var(--c-text);}
.pp-count{font-size:.8rem;font-weight:700;color:var(--c-primary);}
.pp-bar{height:8px;background:var(--c-border);border-radius:100px;overflow:hidden;margin-bottom:8px;}
.pp-bar__fill{height:100%;background:linear-gradient(90deg,var(--c-primary-light),var(--c-primary));border-radius:100px;transition:width .6s var(--ease);}
.pp-hint{font-size:.72rem;color:var(--c-muted);}
.referral-input-wrap{margin-top:4px;}
.referral-label{font-size:.8rem;font-weight:600;color:var(--c-text);margin-bottom:8px;}
.referral-row{display:flex;gap:10px;}
.referral-input{flex:1;text-transform:uppercase;letter-spacing:.06em;}
.referral-apply-btn{font-family:var(--f-body);font-size:.8rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:0 20px;border-radius:var(--radius-sm);border:none;background:var(--c-primary);color:#fff;cursor:pointer;white-space:nowrap;transition:background .22s;}
.referral-apply-btn:hover:not(:disabled){background:var(--c-primary-dark);}
.referral-apply-btn:disabled{opacity:.6;cursor:not-allowed;}
.referral-msg{font-size:.76rem;margin-top:6px;font-weight:500;}
.referral-msg--success{color:var(--c-success);}
.referral-msg--error{color:var(--c-error);}
.form-section--payment{background:linear-gradient(135deg,rgba(45,106,79,.03),var(--c-surface));}
.payment-info{display:flex;flex-direction:column;gap:16px;}
.payment-info__row{display:flex;align-items:flex-start;gap:14px;}
.payment-info__icon{font-size:1.8rem;line-height:1;flex-shrink:0;}
.payment-info__title{font-size:.96rem;font-weight:600;color:var(--c-primary-dark);margin-bottom:3px;}
.payment-info__sub{font-size:.8rem;color:var(--c-muted);font-weight:300;}
.pay-btn{width:100%;font-family:var(--f-body);font-size:.92rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;padding:17px;border-radius:100px;border:none;cursor:pointer;background:var(--c-primary);color:#fff;box-shadow:0 6px 24px rgba(45,106,79,.32);display:flex;align-items:center;justify-content:center;gap:10px;transition:background .22s,transform .22s,box-shadow .22s;animation:secIn .5s var(--ease) .28s both;}
.pay-btn:hover:not(:disabled){background:var(--c-primary-dark);transform:translateY(-2px);box-shadow:0 10px 32px rgba(45,106,79,.4);}
.pay-btn:disabled{opacity:.75;cursor:wait;transform:none;}
.pay-btn--loading{background:var(--c-primary-dark);}
.spinner{width:18px;height:18px;border-radius:50%;border:2.5px solid rgba(255,255,255,.3);border-top-color:#fff;animation:spin .7s linear infinite;}
.submit-note{text-align:center;font-size:.74rem;color:var(--c-muted);margin-top:4px;}
.submit-note__link{color:var(--c-primary);text-decoration:underline;}
.order-summary{background:var(--c-surface);border:1px solid var(--c-border);border-radius:var(--radius);overflow:hidden;top:24px;animation:secIn .5s var(--ease) .15s both;}
.os-toggle{width:100%;display:flex;align-items:center;gap:10px;padding:18px 22px;background:var(--c-bg);border:none;border-bottom:1px solid var(--c-border);cursor:pointer;font-family:var(--f-body);transition:background .2s;}
.os-toggle:hover{background:var(--c-border);}
.os-toggle__label{flex:1;display:flex;align-items:center;gap:10px;font-size:.84rem;font-weight:700;color:var(--c-text);text-align:left;}
.os-toggle__count{font-size:.7rem;background:var(--c-primary);color:#fff;padding:2px 8px;border-radius:100px;font-weight:600;}
.os-toggle__total{font-size:1.2rem;font-weight:600;color:var(--c-primary-dark);}
.os-toggle__arrow{font-size:.7rem;color:var(--c-muted);}
.os-body{padding:20px 22px;}
.os-items{display:flex;flex-direction:column;gap:14px;margin-bottom:4px;}
.os-item{display:flex;align-items:center;gap:12px;}
.os-item__img{width:48px;height:48px;border-radius:8px;flex-shrink:0;background:linear-gradient(135deg,#f0f7f2,#e8f5ec);display:flex;align-items:center;justify-content:center;font-size:1.5rem;position:relative;overflow:visible;}
.os-item__qty{position:absolute;top:-6px;right:-6px;background:var(--c-primary);color:#fff;font-size:.6rem;font-weight:700;width:18px;height:18px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:2px solid var(--c-surface);}
.os-item__info{flex:1;min-width:0;}
.os-item__name{display:block;font-size:.86rem;font-weight:600;color:var(--c-text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
.os-item__cat{display:block;font-size:.7rem;color:var(--c-muted);margin-top:2px;}
.os-item__price{font-size:1rem;font-weight:600;color:var(--c-primary-dark);white-space:nowrap;}
.os-divider{height:1px;background:var(--c-border);margin:16px 0;}
.os-rows{display:flex;flex-direction:column;gap:10px;}
.os-row{display:flex;justify-content:space-between;font-size:.84rem;color:var(--c-muted);}
.os-row--green{color:var(--c-success);}
.free-tag{background:rgba(45,106,79,.08);color:var(--c-primary);font-size:.68rem;font-weight:700;text-transform:uppercase;letter-spacing:.06em;padding:2px 8px;border-radius:100px;}
.os-total{display:flex;justify-content:space-between;align-items:baseline;padding-top:4px;}
.os-total>span:first-child{font-size:.86rem;font-weight:700;color:var(--c-text);}
.os-total__val{font-size:1.5rem;font-weight:600;color:var(--c-primary-dark);}
.os-note{margin-top:16px;font-size:.72rem;color:var(--c-muted);text-align:center;padding:10px 12px;background:var(--c-bg);border-radius:var(--radius-sm);}
@media(max-width:992px){.co-layout{grid-template-columns:1fr;gap:24px;}.order-summary{position:static;width:100%;}}
@media(max-width:768px){.co-layout{display:flex!important;flex-direction:column!important;}.co-container{padding:0 16px;}.form-section{padding:20px 16px;}.form-grid{grid-template-columns:1fr;gap:14px;}.co-header{padding:28px 0;}.stepbar{padding:20px 0;justify-content:space-between;}.step__label{display:none;}.step__circle{width:28px;height:28px;font-size:.7rem;}.step__line{margin:0 6px;}.pay-btn{padding:14px;font-size:.85rem;}.referral-row{flex-direction:column;}}
@media(max-width:480px){.co-container{padding:0 12px;}.co-header__title{font-size:1.6rem;}.form-section__title{font-size:1.1rem;}.input,.textarea,.select{font-size:.85rem;padding:10px 12px;}}
`;